import { Record } from 'immutable';
import { AdjustmentType } from './adjustment-type.enum';

const AdjustmentRecord = Record({
  eventAdjustmentId: null,
  eventId: null,
  adjustmentAmount: 0,
  adjustmentType: null,
  createdDate: null
});

export class Adjustment extends AdjustmentRecord {
  eventAdjustmentId: number;
  eventId: number;
  adjustmentAmount: number;
  adjustmentType: AdjustmentType;
  createdDate: Date;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/adjustment.ts